import { render } from "./AddEditPriceList.vue?vue&type=template&id=73f9dc7d"
import script from "./AddEditPriceList.vue?vue&type=script&lang=js"
export * from "./AddEditPriceList.vue?vue&type=script&lang=js"

import "./AddEditPriceList.vue?vue&type=style&index=0&id=73f9dc7d&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__